export default __webpack_public_path__ + "static/media/gal8.cffd0c65.jpg";